// Resolves Vinted Products page rows into the internal products.id values
// that POST /api/bulk-upload-vinted expects (same ids View Products sends).
//
// Rows on the Vinted Products page are vinted_listed_items records:
//   row.product_id          -> Vinted listing id (used by Bulk Delete)
//   row.internal_product_id -> our products.id
// product_vinted_details.internal_product_id is NOT used: it is wrong for
// some listings (swapped between products).

export const getInternalProductId = (row) => {
  const id = Number(row?.internal_product_id);
  return Number.isInteger(id) && id > 0 ? id : null;
};

/**
 * @param {Array<object>} rows selected vinted_listed_items rows
 * @returns {{ productIds: number[], skipped: Array<{ vintedId, title, reason }> }}
 */
export const resolveBulkUploadProductIds = (rows) => {
  const productIds = [];
  const skipped = [];
  const seen = new Set();

  rows.forEach((row) => {
    const skip = (reason) =>
      skipped.push({ vintedId: row.product_id, title: row.title, reason });

    const internalId = getInternalProductId(row);
    if (!internalId) return skip("not linked to an internal product");
    if (row.status !== "Draft") {
      return skip(`still ${row.status || "Active"} on Vinted (only Draft rows are re-uploaded)`);
    }
    if (String(row.internal_product_status || "").toLowerCase() === "sold") {
      return skip("internal product is sold");
    }
    if (Number(row.internal_has_active_listing) === 1) {
      return skip("product already has an Active Vinted listing");
    }
    if (seen.has(internalId)) return skip("same product selected twice");

    seen.add(internalId);
    productIds.push(internalId);
  });

  return { productIds, skipped };
};
